var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jo-ocis",attrs:{"id":"ocis"}},[(_vm.lang == 'zh')?_c('h2',[_vm._v("OCIS码")]):_c('h2',[_vm._v("OCIS codes")]),_vm._v(" "),_c('p',_vm._l((_vm.ocis),function(item,index){return _c('span',{staticClass:"a"},[_vm._v("\n      "+_vm._s(item)+_vm._s(index!=(_vm.ocis.length-1)?';':'')+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-422cb638","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/componentsMobile/maincontent/body/ocis/ocis.vue
// module id = null
// module chunks = 